import CarWashService from "../../../../services/CarWashService";
import Modal from "@/components/Modal";
import Messages from "@/utils/messages";
export default {
  name: "CarWashMenejerList",
  data: () => ({
    carWashList: [],
    NewCarWashModalData: {
      Show: false,
      Name: null,
      TaxCode: null,
      Address: null,
      PhoneNumber: null,
      ContactPerson: null,
      Buttons: [],
    },
  }),
  components: { Modal },
  mounted() {
    this.GetList();
  },
  methods: {
    GetList() {
      CarWashService.GetList().then((res) => {
        this.carWashList = res.carWashList;
      });
    },
    GoToDetails(carwash) {
      this.$router.push({
        name: "CarWashDetail",
        params: { carwashid: carwash.id },
      });
    },

    ShowModal() {
      this.NewCarWashModalData.Show = true;
      this.NewCarWashModalData.Buttons.push({
        name: "შენახვა",
        class: "btn indigo lighten-1",
        style: "margin-right: 4px;",
        funq: this.AddNewCarWash,
      });
      this.NewCarWashModalData.Buttons.push({
        name: "დახურვა",
        class: "btn yellow darken-1 black-text",
        funq: this.HideModal,
      });
    },
    AddNewCarWash() {
      if (!this.NewCarWashModalData.Name) {
        this.$message(Messages["CarWashAddNoName"]);
      } else if (!this.NewCarWashModalData.TaxCode) {
        this.$message(Messages["CarWashAddNoTaxCode"]);
      } else if (
        !this.NewCarWashModalData.PhoneNumber ||
        this.NewCarWashModalData.PhoneNumber.length != 9 ||
        this.NewCarWashModalData.PhoneNumber[0] != 5 ||
        !Number(this.NewCarWashModalData.PhoneNumber)
      ) {
        this.$message(Messages["CarWashAddNoPhoneNumber"]);
      } else if (!this.NewCarWashModalData.ContactPerson) {
        this.$message(Messages["CarWashAddNoContactPerson"]);
      } else {
        CarWashService.AddNewCarWash(
          this.NewCarWashModalData.Name,
          this.NewCarWashModalData.TaxCode,
          this.NewCarWashModalData.Address,
          this.NewCarWashModalData.PhoneNumber,
          this.NewCarWashModalData.ContactPerson
        ).then(() => {
          this.HideModal();
          this.GetList();
        });
      }
    },
    HideModal() {
      this.NewCarWashModalData.Show = false;
      this.NewCarWashModalData.Name = null;
      this.NewCarWashModalData.TaxCode = null;
      this.NewCarWashModalData.PhoneNumber = null;
      this.NewCarWashModalData.ContactPerson = null;
      this.NewCarWashModalData.Buttons = [];
    },
  },
};
